import Workspace from 'iam/models/Workspace'
import { Membership } from 'iam/WorkspaceMembershipStore'
import { CallCenterWorkspaceMemberMatch } from './models/CallCenterSearchResult'

export function isCallCenterEnabledInWorkspace(workspace: Workspace) {
  return Boolean(workspace.config.call_center_config?.enabled)
}

export function filterCallCenterMemberships(memberships: Membership[]) {
  return memberships.filter((membership) =>
    isCallCenterEnabledInWorkspace(membership.workspace),
  )
}

export function filterCallCenterWorkspaceMembersMatches(
  workspaceMembersMatches: CallCenterWorkspaceMemberMatch[],
) {
  return workspaceMembersMatches.filter((match) =>
    isCallCenterEnabledInWorkspace(match.workspace),
  )
}
